import { http_api } from "../../leadg-api";
const getChartData = (startDate, endDate, granularity, chartType, weekNumber, year) => {
    let url = `kpi-dashboard/chart-data?startDate=${startDate}&endDate=${endDate}&granularity=${granularity}&chartType=${chartType}`;
    if (weekNumber !== undefined)
        url += `&weekNumber=${weekNumber}`;
    if (year !== undefined)
        url += `&year=${year}`;
    return http_api.get(url);
};
const getChartDetail = (periodStart, periodEnd, chartType) => {
    return http_api.get(`kpi-dashboard/chart-detail?periodStart=${periodStart}&periodEnd=${periodEnd}&chartType=${chartType}`);
};
const getLeaderboard = (startDate, endDate, granularity, weekNumber, year) => {
    let url = `kpi-dashboard/leaderboard?startDate=${startDate}&endDate=${endDate}&granularity=${granularity}`;
    if (weekNumber !== undefined)
        url += `&weekNumber=${weekNumber}`;
    if (year !== undefined)
        url += `&year=${year}`;
    return http_api.get(url);
};
const getLeaderboardDetail = (agentId, startDate, endDate, type) => {
    return http_api.get(`kpi-dashboard/leaderboard-detail?agentId=${agentId}&startDate=${startDate}&endDate=${endDate}&type=${type}`);
};
const getWeeklyTargets = (year) => {
    return http_api.get(`kpi-dashboard/weekly-targets?year=${year}`);
};
const createWeeklyTarget = (target) => {
    return http_api.post("kpi-dashboard/weekly-targets", target);
};
const updateWeeklyTarget = (id, target) => {
    return http_api.put(`kpi-dashboard/weekly-targets/${id}`, target);
};
const deleteWeeklyTarget = (id) => {
    return http_api.delete(`kpi-dashboard/weekly-targets/${id}`);
};
const DashboardKpiApi = {
    getChartData,
    getChartDetail,
    getLeaderboard,
    getLeaderboardDetail,
    getWeeklyTargets,
    createWeeklyTarget,
    updateWeeklyTarget,
    deleteWeeklyTarget,
};
export default DashboardKpiApi;
